import axiosInstance from './axios';

export const brandService = {
  getBrands: async (params = {}) => {
    const response = await axiosInstance.get('/brands', { params });
    return response.data;
  },

  getBrand: async (id) => {
    const response = await axiosInstance.get(`/brands/${id}`);
    return response.data;
  },

  createBrand: async (brandData) => {
    const response = await axiosInstance.post('/brands', brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateBrand: async (id, brandData) => {
    const response = await axiosInstance.put(`/brands/${id}`, brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteBrand: async (id) => {
    const response = await axiosInstance.delete(`/brands/${id}`);
    return response.data;
  },
};
